import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
export default {
  name: "community-tag",
  data: function data() {
    return {
      searchForm: {
        page: 1,
        limit: 20,
        name: "",
        type: ""
      },
      // 搜索表单

      form: {},
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      rules: {
        name: [{
          required: true,
          message: "请输入标签名称",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.page = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCommunityTagList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.sortLifestyleTag(row);
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.$refs["form"].validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        if (!valid) {
                          _context4.n = 4;
                          break;
                        }
                        if (!_this4.form.id) {
                          _context4.n = 2;
                          break;
                        }
                        _context4.n = 1;
                        return _this4.$api.updateCommunityTag(_this4.form);
                      case 1:
                        _context4.n = 3;
                        break;
                      case 2:
                        _context4.n = 3;
                        return _this4.$api.addCommunityTag(_this4.form);
                      case 3:
                        _this4.$operationLog.push({
                          code: _this4.form.id ? "edit" : "add",
                          operationType: "text",
                          detailBatchNo: _this4.form.name
                        });
                        _this4.dialogVisible = false;
                        _this4.form = {};
                        _this4.getData();
                      case 4:
                        return _context4.a(2);
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    close: function close() {
      this.$refs["form"].clearValidate();
    },
    deleteItem: function deleteItem(row) {
      var _this5 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this5.$api.deleteCommunityTag(row.id);
            case 1:
              _this5.$message.success("删除成功！");
              _this5.$operationLog.push({
                code: 'delete',
                operationType: "text",
                detailBatchNo: row.name
              });
              _this5.getData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    }
  }
};